import loading from './loading'

const install = function (Vue) {
    Vue.component(loading.name, loading)
    const LoadingConstructor = Vue.extend(loading)
    const creatdom = function (el, binding) {
        const options = {}
        options.fullScreen = !!binding.modifiers.fullscreen
        if (options.fullScreen) {
            options.top = 0
            options.left = 0
            options.width = '100%'
            options.height = '100%'
        } else {
            ['top', 'left'].forEach(function (property) {
                var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft'
                options[property] = el.getBoundingClientRect()[property] +
            document.body[scroll] +
            document.documentElement[scroll] +
            'px'
            });
            ['height', 'width'].forEach(function (property) {
                options[property] = el.getBoundingClientRect()[property] + 'px'
            })
        }
        var component = new LoadingConstructor({
            data: options
        }).$mount()
        var node = document.querySelector('.loading')
        if (node && node.parentNode) {
            node.parentNode.removeChild(node)
        }
        if (binding.value === true) {
            document.querySelector('body').appendChild(component.$el)
        } else {
            node = document.querySelector('.loading')
            if (node && node.parentNode) {
                node.parentNode.removeChild(node)
            }
        }
    }
    Vue.directive('loading', {
        inserted: function (el, binding) {       
            if (binding.value) {
                creatdom(el, binding)
            }
        },
        update: function (el, binding) {     
            if (binding.oldValue != binding.value) {
                creatdom(el, binding)
            }
        }
    })
}

export default install



// WEBPACK FOOTER //
// ./src/components/loading/index.js